import { render, staticRenderFns } from "./CallOut.vue?vue&type=template&id=01a1786a&scoped=true"
import script from "./CallOut.vue?vue&type=script&lang=js"
export * from "./CallOut.vue?vue&type=script&lang=js"
import style0 from "./CallOut.vue?vue&type=style&index=0&id=01a1786a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a1786a",
  null
  
)

export default component.exports